import { json, postBiz } from '../core/coreapi';

import {
  DirectBudgetLine,
  DirectBudgetWorkbenchModel,
} from './directbudget.models';

import { normalizeWorkbench } from './directbudget.normalizers';

const SERVICE = 'directbudget';

export async function getDirectBudgetWorkbench(
  pci: number
): Promise<DirectBudgetWorkbenchModel> {
  
  const r = json(
    await postBiz({ s: SERVICE, a: 'workbench', pci })
  );
  return normalizeWorkbench(r);
}

export async function saveDirectBudgetLines(
  headerid: number,
  stamp: string,
  rows: DirectBudgetLine[]
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'linesave',
      hid: headerid,
      stp: stamp,
      rcd: rows.filter(
        (r) =>
          r.__dirty ||
          r._state === 'new' ||
          r._state === 'deleted'
      ),
    })
  );
}


export async function createDirectBudget(
  pci: number,
  name: string
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'create',
      pci,
      nam: name || '',
    })
  );
}

export async function validateDirectBudget(
  headerid: number
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'validate',
      hid: headerid,
    })
  );
}

export async function submitDirectBudget(
  headerid: number,
  stamp: string,
  notes: string
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'submit',
      hid: headerid,
      stp: stamp,
      nts: notes || '',
    })
  );
}

export async function reopenDirectBudget(
  headerid: number,
  stamp: string,
  reason: string
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'reopen',
      hid: headerid,
      stp: stamp,
      rsn: reason || '',
    })
  );
}

// const ensureSuccess = <T = any>(result: any): T => {
//   const rc = Number(result?.rc ?? -1);

//   if (rc !== 0) {
//     throw new Error(
//       result?.em || result?.sm || 'The Direct Budget operation failed.'
//     );
//   }

//   return result?.sd as T;
// };

// export async function getDirectBudgetWorkbench(
//   pci: number
// ): Promise<DirectBudgetWorkbenchModel> {
//   const r = await postBiz({ s: SERVICE, a: 'workbench', pci });
//   return normalizeWorkbench(json(r));
// }

// export async function createDirectBudget(pci: number, name: string) {
//   return ensureSuccess(
//     json(await postBiz({ s: SERVICE, a: 'create', pci, nam: name || '' }))
//   );
// }

// export async function saveDirectBudgetLines(
//   headerid: number,
//   stamp: string,
//   rows: DirectBudgetLine[]
// ) {
//   return ensureSuccess(
//     json(
//       await postBiz({
//         s: SERVICE,
//         a: 'linesave',
//         hid: headerid,
//         stp: stamp,
//         rcd: rows.filter(
//           (r) => r.__dirty || r._state === 'new' || r._state === 'deleted'
//         ),
//       })
//     )
//   );
// }

// export async function validateDirectBudget(headerid: number) {
//   return ensureSuccess(
//     json(await postBiz({ s: SERVICE, a: 'validate', hid: headerid }))
//   );
// }

// export async function submitDirectBudget(
//   headerid: number,
//   stamp: string,
//   notes: string
// ) {
//   const response = json(
//     await postBiz({
//       s: SERVICE,
//       a: 'submit',
//       hid: headerid,
//       stp: stamp,
//       nts: notes || '',
//     })
//   );

//   return ensureSuccess(response);
// }

// export async function reopenDirectBudget(
//   headerid: number,
//   stamp: string,
//   reason: string
// ) {
//   return json(
//       await postBiz({
//         s: SERVICE,
//         a: 'reopen',
//         hid: headerid,
//         stp: stamp,
//         rsn: reason,
//       })
//   );
// }
